<template>
  <header class="edu-header  header-sticky  header-style-2 header-default header-transparent">
    <!-- <header class="edu-header  header-sticky  header-style-2 header-default disabled-transparent"> -->
    <div class=" row align-items-center">
      <div class="col-lg-4 col-xl-3 col-md-6 col-6">
        <div class="logo">
          <router-link to="/" @click="click_m()">
            <img class="logo-light" :src="url_api + '/InstitucionUpea/' + Institucion.institucion_logo
              " width="70" height="70" alt="Site Logo">
          </router-link>
          <h4 class="logo_name text-white">{{ Institucion.institucion_nombre }}</h4>
        </div>
      </div>
      <div class="col-lg-6 col-xl-7 d-none d-xl-block">
        <nav class="mainmenu-nav d-none d-lg-block">
          <ul class="mainmenu">
            <li class="has-droupdown"><router-link to="/" class=" text-white">Inicio</router-link>
              <ul class="submenu">
                <li><router-link to="/about" @click="click_m()">Sobre Nosotros</router-link></li>
                <!-- <li><router-link :to="{ name: 'About', hash: '#campo' }" @click="click_m()">Campo
                    laboral
                  </router-link>
                </li> -->
                <li><router-link to="/campoLaboral" @click="click_m()">Campo
                    laboral</router-link>
                </li>
              </ul>
            </li>
            <li class="has-droupdown"><a href="#" class=" text-white">Convocatorias</a>
              <ul class="submenu">
                <li v-for="( mc, id_mc ) of  MenuConv " :key="id_mc">
                  <router-link :to="'/convocatorias/' + mc.idtipo_conv_comun" @click="click_m()">
                    {{ mc.tipo_conv_comun_titulo.toLowerCase() }}
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="has-droupdown"><a href="#" class=" text-white">Cursos</a>
              <ul class="submenu">
                <li v-for="( mc, id_mc ) of  MenuCur " :key="id_mc">
                  <router-link :to="'/cursos/' + mc.idtipo_curso_otros" @click="click_m()">
                    {{ mc.tipo_conv_curso_nombre.toLowerCase() }}
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="has-droupdown">
              <router-link to="/convenios" class="link text-white">Convenios</router-link>
            </li>
            <li class="has-droupdown">
              <a href="#" class=" text-white">Mas</a>
              <ul class="submenu">
                <li><router-link to="/servicios" @click="click_m()">Servicios</router-link></li>
                <!-- <li><router-link to="/ofertas" @click="click_m()">OFERTAS ACADÉMICAS</router-link></li> -->
                <li><router-link to="/publicaciones" @click="click_m()">Publicaciones</router-link></li>
                <li><router-link to="/investigacion" @click="click_m()">Investigación</router-link></li>
                <!-- <li><router-link to="/gaceta" @click="click_m()">GACETA</router-link></li> -->
                <!-- <li><router-link to="/eventos" @click="click_m()">EVENTOS</router-link></li> -->
                <li><router-link to="/videos" @click="click_m()">Videos</router-link></li>
                <li class="has-droupdown">
                  <a href="https://www.finesoftware.es/software-geotecnico/" class="link" target="_blank">
                    Software
                    Geotécnico</a>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col-lg-2 col-xl-2 col-md-6 col-6">
        <div class="header-right d-flex justify-content-end">
          <div class="header-menu-bar">
            <div class="quote-icon quote-user d-none d-md-block ml--15 ml_sm--5">
              <a class="edu-btn btn-medium left-icon header-button" href="http://administracionpaginas.upea.edu.bo/login"
                target="_blank"><i class="ri-user-line"></i>Iniciar Sesión</a>
            </div>
          </div>

          <div class="mobile-menu-bar ml--15 ml_sm--5 d-block d-xl-none">
            <div class="hamberger">
              <button @click="eventMenu" class="white-box-icon hamberger-button header-menu">
                <i class="ri-menu-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <div class="popup-mobile-menu " :class="{ 'active': isOpenMenu }">
    <div class="inner">
      <div class="header-top">
        <div class="logo">
          <router-link to="/" @click="click_m()" style="display: inline-flex; align-items: center;">
            <img :src="url_api + '/InstitucionUpea/' + Institucion.institucion_logo" alt=" Site Logo">
            <h4 class="text-dark m-0">{{ Institucion.institucion_nombre }}</h4>
          </router-link>
        </div>
        <div class="close-menu">
          <button @click="eventMenu" class="close-button">
            <i class="ri-close-line"></i>
          </button>
        </div>
      </div>
      <ul class="mainmenu">
        <li class="has-droupdown"><router-link @click="toggleSubMenu" to="/">Inicio</router-link>
          <ul class="submenu">
            <li><router-link to="/about" @click="click_m()">Sobre Nosotros</router-link></li>
          </ul>
        </li>
        <li class="has-droupdown"><a @click="toggleSubMenu" href="#">Convocatorias</a>
          <ul class="submenu">
            <li v-for="( mc, id_mc ) of  MenuConv " :key="id_mc">
              <router-link :to="'/convocatorias/' + mc.idtipo_conv_comun" @click="click_m()">
                {{ mc.tipo_conv_comun_titulo }}
              </router-link>
            </li>
          </ul>
        </li>
        <li class="has-droupdown"><a href="#" @click="toggleSubMenu">Cursos</a>
          <ul class="submenu">
            <li v-for="( mc, id_mc ) of  MenuCur " :key="id_mc">
              <router-link :to="'/cursos/' + mc.idtipo_curso_otros" @click="click_m()">
                {{ mc.tipo_conv_curso_nombre }}
              </router-link>
            </li>
          </ul>
        </li>
        <li class="has-droupdown">
          <a href="#" @click="toggleSubMenu">Mas</a>
          <ul class="submenu">
            <li><router-link to="/servicios" @click="click_m()">SERVICIOS</router-link></li>
            <li><router-link to="/ofertas" @click="click_m()">OFERTAS ACADÉMICAS</router-link></li>
            <li><router-link to="/publicaciones" @click="click_m()">PUBLICACIONES</router-link></li>
            <!-- <li><router-link to="/gaceta" @click="click_m()">GACETA</router-link></li>
            <li><router-link to="/eventos" @click="click_m()">EVENTOS</router-link></li>
            <li><router-link to="/videos" @click="click_m()">VIDEOS</router-link></li> -->
          </ul>
        </li>
        <li class="has-droupdown">
          <a href="#" @click="toggleSubMenu">Links</a>
          <ul class="submenu">
            <li v-for=" ( link, id_link ) of  Links " :key="id_link">
              <a :href="link.ei_link" target="_blank" :title="link.ei_tipo">
                {{ link.ei_nombre.toUpperCase() }}
              </a>
            </li>
          </ul>
        </li>

      </ul>
    </div>
  </div>
  <!-- Start Search Popup  -->
  <div class="edu-search-popup" :class="{ 'open': isOpenSearch }">
    <div class=" close-button">
      <button @click="eventSearch" class="close-trigger"><i class="ri-close-line"></i></button>
    </div>
    <div class="inner">
      <form class="search-form" action="#">
        <input type="text" class="eduvibe-search-popup-field" placeholder="Search Here...">
        <button class="submit-button"><i class="icon-search-line"></i></button>
      </form>
    </div>
  </div>
</template>
<style scoped>
@media only screen and (max-width: 991px) {

  /* .logo_name {
    display: none;
  }

  .logo-light {
    display: none;
  } */
  .logo_name {
    font-size: 1.4rem !important;
  }
}

.logo {
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo_name {
  margin: 0;
  font-size: 2rem;
}

.header-color .mainmenu-nav .mainmenu>li>a {
  color: #fff;
}

.edu-header.header-sticky.sticky {
  background-color: var(--color-primary) !important;
}
</style>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      sopen: false,
      Links: [],

      m_inicio: false,
      m_conv: false,
      m_cur: false,
      m_mas: false,
      m_link: false,

      isOpenSearch: false,
      isOpenMenu: false,
      isSubMenuOpen: true,


    }
  },
  computed: {
    ...mapState(["url_api", "MenuConv", "MenuCur", "Institucion", "getter"]),
  },
  methods: {
    // handleScroll() {
    //   if (window.scrollY == 0 && this.$route.path === '/') {
    //   } else {
    //     // console.log('Se hizo scroll. Posición:', window.scrollY);
    //   }
    // },
    click_m() {
      this.$store.commit("clickLink");
      // this.$store.commit("idEncrypt")
    },
    showSubMenu(id) {
      switch (id) {
        case "m_inicio":
          this.m_inicio = true;
          this.m_conv = false;
          this.m_cur = false;
          this.m_mas = false;
          this.m_link = false;
          break;
        case "m_conv":
          this.m_inicio = false;
          this.m_conv = true;
          this.m_cur = false;
          this.m_mas = false;
          this.m_link = false;
          break;
        case "m_cur":
          this.m_inicio = false;
          this.m_conv = false;
          this.m_cur = true;
          this.m_mas = false;
          this.m_link = false;
          break;
        case "m_mas":
          this.m_inicio = false;
          this.m_conv = false;
          this.m_cur = false;
          this.m_mas = true;
          this.m_link = false;
          break;
        case "m_link":
          this.m_inicio = false;
          this.m_conv = false;
          this.m_cur = false;
          this.m_mas = false;
          this.m_link = true;
          break;

        default:
          console.log("");
          break;
      }
    },
    async getLinks() {
      try {
        let res = await this.axios.get(
          "/api/linksIntExtAll/" + process.env.VUE_APP_ID_INSTITUCION
        );
        this.Links = res.data;
      } catch (error) {
        console.log(error);
      }
    },

    eventSearch() {
      this.isOpenSearch = !this.isOpenSearch;
    },
    eventMenu() {
      this.isOpenMenu = !this.isOpenMenu;
    },
    toggleSubMenu(event) {
      const submenu = event.target.nextElementSibling;
      const link = event.currentTarget;
      link.classList.toggle('open');
      submenu.classList.toggle('active');
      submenu.style.display = submenu.style.display === 'none' || submenu.style.display === '' ? 'block' : 'none';


    },
  },
  created() {
    this.getLinks();
  },
  mounted() {
    if (this.getter) {
      window.addEventListener('scroll', this.handleScroll);
      this.getLinks();
      this.$store.state.getter = false;
    }
  },
  updated() {
    if (this.getter) {
      this.$store.state.getter = false;
    }
  }
}
</script>